import { setUserPreferences } from '../services/userPreferences'

export const saveCategoryOpacity = (data) => {
	setUserPreferences({ path: 'maps', data })
}

export const saveFavoriteStates = (data) => {
	setUserPreferences({ path: 'maps', data })
}
export const saveFavoriteIcons = data => {
	setUserPreferences({ path: 'maps', data })
}

export const saveLayers = (data) => {
	setUserPreferences({ path: 'maps', data })
}

export const savePinnedCollection = (data) => {
	setUserPreferences({ path: 'maps', data })
}

export const saveRecentStyles = (data) => {
	setUserPreferences({ path: 'maps', data })
}

export const saveTerraiAnalysys = (data) => {
	setUserPreferences({ path: 'maps', data })
}

export const saveVisibleFeatures = (data) => {
	setUserPreferences({ path: 'maps', data })
}